import Vue from 'vue'
import Router from 'vue-router'
import projects from './modules/projects'
import store from '@/store/index'
// import VueCookie from 'vue-cookie'
import _localStorage from '@/plugins/local_storage'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '*',
    redirect: '/dashboard'
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    beforeEnter (from, to, next) {
      if (!_localStorage.get(process.env.VUE_APP_TOKEN)) {
        next()
      } else {
        next('/dashboard')
      }
    }
  }, {
    path: '/customer_login',
    name: 'customer_login',
    component: () => import('@/views/auth/CustomerLogin')
    /* beforeEnter (from, to, next) {
      if (!_localStorage.get(process.env.VUE_APP_TOKEN)) {
        next()
      } else {
        next('/dashboard')
      }
    } */
  }, {
    path: '/customer_projects',
    name: 'customer_projects',
    component: () => import('@/views/Projects/CustomerProjects.vue')
  }, {
    path: '/loggedout',
    name: 'loggedout',
    component: () => import('@/views/auth/LogoutSuccess.vue')
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Dashboard/Dashboard.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/stamptime',
    name: 'stamptime',
    component: () => import('@/views/StampTime/StampTime.vue'),
    meta: { requiresAuth: true }
  },
  ...projects,
  {
    path: '/hourlogging',
    name: 'hourlogging',
    component: () => import('@/views/Hourlogging/Hourlogging.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/approval',
    name: 'approval',
    component: () => import('@/views/Approval/Approval.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/Reports/Reports.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/worktypes',
    name: 'worktypes',
    component: () => import('@/views/Settings/Worktypes/Worktypes.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/activities',
    name: 'activities',
    component: () => import('@/views/Settings/GeneralActivity/GeneralActivity.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/holidays',
    name: 'holidays',
    component: () => import('@/views/Settings/Holidays/Holidays.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/user',
    name: 'user',
    component: () => import('@/views/Settings/User/UserList.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/company_settings',
    name: 'company_settings',
    component: () => import('@/views/Settings/CompanySettings/CompanySettings.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/sharepoint_settings',
    name: 'sharepoint_settings',
    component: () => import('@/views/Settings/SharepointSettings/Index.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/callback_success',
    name: 'callback_success',
    component: () => import('@/views/auth/CallbackSuccess.vue')
  }, {
    path: '/callback_error',
    name: 'callback_error',
    component: () => import('@/views/auth/CallbackError.vue')
  }, {
    path: '/projectsharepoint/:id?',
    name: 'projectsharepoint',
    component: () => import('@/views/ProjectSharepointList/Index.vue')
  }, {
    path: '/companysharepoint/:id?',
    name: 'companysharepoint',
    component: () => import('@/views/CompanySharepointList/Index.vue')
  }]
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!_localStorage.get(process.env.VUE_APP_TOKEN) || !_localStorage.get(process.env.VUE_APP_USER)) {
      store.commit('resetAuth', false)
      _localStorage.remove(process.env.VUE_APP_TOKEN) // VueCookie.delete(process.env.VUE_APP_TOKEN)
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else next()
  } else next()
})

export default router
